"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSurveyCompletionPercentage = exports.isSectionComplete = exports.getWidgetChoiceFromValue = exports.removeGroupedObjects = exports.addGroupedObjects = exports.interviewOnOrAfter = exports.surveyEnded = exports.surveyStarted = exports.replaceVisitedPlaceShortcuts = exports.getVisitedPlacesArray = exports.getVisitedPlaces = exports.getPersonsArray = exports.getPersons = exports.isPhoneNumber = exports.formatGeocodingQueryStringFromMultipleFields = exports.setValidation = exports.getValidation = exports.getCurrentPerson = exports.getHousehold = exports.setResponse = exports.getResponse = exports.parseValue = exports.getPath = exports.devLog = exports.interpolatePath = exports.parseInteger = exports.parse = exports.parseBoolean = exports.parseString = exports.translateString = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const get_1 = __importDefault(require("lodash/get"));
const set_1 = __importDefault(require("lodash/set"));
const uuid_1 = require("uuid");
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const moment_1 = __importDefault(require("moment"));
const geojson_validation_1 = require("geojson-validation");
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const LE = __importStar(require("chaire-lib-common/lib/utils/LodashExtensions"));
const odSurveyHelpers = __importStar(require("../services/odSurvey/helpers"));
// The helpers in this file are used to manipulate and parse the survey model,
// regardless of the data it contains. The involve the higher level interview
// object and the widget data and functions.
const translateString = (i18nData, i18nObj, interview, path, user) => {
    return typeof i18nData === 'function'
        ? i18nData(i18nObj.t, interview, path, user)
        : typeof i18nData === 'object'
            ? (0, exports.parseString)(i18nData[i18nObj.language], interview, path, user)
            : i18nData;
};
exports.translateString = translateString;
/**
 * Verify if the value is a function. If so, call it with the other parameters,
 * otherwise, simply return the value itself
 *
 * @param value The value to parse
 * @param interview The interview attributes
 * @param path The path of the field being parsed, in the interview (response?)
 * @param user The current user's information
 * @returns The parsed string value, or the value itself if it is a string
 */
const parseString = (value, interview, path, user) => {
    return typeof value === 'function' ? value(interview, path, user) : value;
};
exports.parseString = parseString;
/**
 * Verify if the value is a function. If so, call it with the other parameters,
 * otherwise, simply return the value itself, or the defaultBoolean
 *
 * @param value The value to parse
 * @param interview The interview attributes
 * @param path The path of the field being parsed, in the interview (response?)
 * @param user The current user's information
 * @param defaultBoolean default boolean value if undefined or null. TODO Do we
 * really want a default value of true?
 * @returns The parsed string value, or the value itself if it is a string
 */
const parseBoolean = (value, interview, path, user, defaultBoolean = true) => {
    if (value === undefined || value === null) {
        return defaultBoolean;
    }
    // FIXME Code taken from legacy workspace and kept as is to avoid breaking
    // current surveys, but if the function returns undefined, shouldn't it use
    // the default value?
    if (typeof value === 'function') {
        const resultValue = value(interview, path, user);
        return Array.isArray(resultValue) ? resultValue[0] : resultValue;
    }
    return value;
};
exports.parseBoolean = parseBoolean;
/**
 * Verify if the value is a function. If so, call it with the other parameters,
 * otherwise, simply return the value itself
 *
 * TODO: Can this parse function replace parseInteger and parseString?
 *
 * @param value The value to parse
 * @param interview The interview attributes
 * @param path The path of the field being parsed, in the interview (response?)
 * @param user The current user's information
 * @returns The parsed value of type T, or the value itself if it is a string
 */
const parse = (value, interview, path, user) => {
    return typeof value === 'function' ? value(interview, path, user) : value;
};
exports.parse = parse;
/**
 * Verify if the value is a function. If so, call it with the other parameters,
 * otherwise, simply return the value itself, return an integer number
 *
 * @param value The value to parse
 * @param interview The interview attributes
 * @param path The path of the field being parsed, in the interview (response?)
 * @param user The current user's information
 * @returns The parsed number value, or the value itself
 */
const parseInteger = (value, interview, path, user) => {
    if (typeof value === 'function') {
        const parsedValue = value(interview, path, user);
        return typeof parsedValue === 'string' ? parseInt(parsedValue) : parsedValue;
    }
    return value;
};
exports.parseInteger = parseInteger;
/**
 * Replace response placeholders specified between brackets in a path by the
 * corresponding value in the interview response.
 *
 * For example, if the value of the 'section1.field1' response is 'foo', path
 * 'prefix.{section1.field1}.suffix' would resolve to 'prefix.foo.suffix'
 *
 * @param interview The interview
 * @param path The path, with possibly response placeholders between brackets
 * @returns The path with interpolated response
 */
const interpolatePath = (interview, path) => {
    const splittedInterpolationPath = path ? path.match(/\{(.+?)\}/g) : null;
    let interpolatedPath = path;
    if (splittedInterpolationPath) {
        for (let i = 0, count = splittedInterpolationPath.length; i < count; i++) {
            const interpolationString = splittedInterpolationPath[i];
            const interpolationStringWithoutBrakets = interpolationString.substring(1, interpolationString.length - 1);
            const response = (0, exports.getResponse)(interview, interpolationStringWithoutBrakets);
            if (typeof response === 'string' || typeof response === 'number' || typeof response === 'boolean') {
                interpolatedPath = interpolatedPath.split(interpolationString).join(String(response));
            }
            else {
                (0, exports.devLog)('Trying to get interpolated path with an invalid response, will add \'unknown\' instead');
                interpolatedPath = interpolatedPath.split(interpolationString).join('unknown');
            }
        }
    }
    return interpolatedPath;
};
exports.interpolatePath = interpolatePath;
/**
 * Log a list of arguments only if in development mode
 *
 * @param args List of arguments to log
 */
const devLog = function (...args) {
    if (process.env.NODE_ENV === 'development') {
        console.log.apply(null, args);
    }
};
exports.devLog = devLog;
/**
 * Update a dot-separated path (for example a path to query into an object) with
 * a relative path that can potentially go backward.
 *
 * For example, if the path is `foo.bar.test` and relative path is
 * `../../myField`, the result path is `foo.myField`.
 *
 * @param path The dot-seprated path to update
 * @param relativePath The relative path that should contain at least one ../,
 * otherwise, it is ignored
 * @returns The new absolute path after relative elements are resolved
 */
const getPath = function (path, relativePath) {
    if (path === undefined || path === null) {
        return null;
    }
    if (relativePath) {
        // relativePath include one ../ or more and a relative path at the end
        const relativePathSplitted = relativePath.split('../');
        const backwardCount = relativePathSplitted.length - 1;
        const newRelativePath = relativePathSplitted[relativePathSplitted.length - 1];
        let newPath = undefined;
        if (backwardCount > 0) {
            const splittePath = path.split('.');
            // TODO What if splittedPath.length is smaller than backwardCount?
            // Now it returns the same as if both were equal, but should it be
            // null?
            const prefixPath = splittePath.splice(0, splittePath.length - backwardCount).join('.');
            newPath =
                newRelativePath === '' ? prefixPath : `${prefixPath}${prefixPath !== '' ? '.' : ''}${newRelativePath}`;
        }
        return newPath && newPath !== '' ? newPath : null;
    }
    return path;
};
exports.getPath = getPath;
// inner function to parse a single value based on its datatype
// This is used by the parseValue function to handle both single values and arrays
const _parseSingleValue = (value, datatype) => {
    // If datatype is undefined, just return the value
    if (datatype === undefined) {
        return value;
    }
    if (datatype === 'integer') {
        return !(typeof value === 'string' || typeof value === 'number' || value === null)
            ? undefined
            : LE._toInteger(value);
    }
    if (datatype === 'float') {
        return !(typeof value === 'string' || typeof value === 'number' || value === null)
            ? undefined
            : LE._toFloat(value);
    }
    if (datatype === 'boolean') {
        return value === undefined ? undefined : LE._booleish(value);
    }
    if (datatype === 'geojson') {
        // Add the properties to the value if it is an object and it does not have properties
        if (value !== null && typeof value === 'object' && value['properties'] === undefined) {
            value.properties = {};
        }
        // For geojson, we only accept valid geojson objects
        return value === undefined ? undefined : value && (0, geojson_validation_1.isFeature)(value) ? value : null;
    }
    if (value === '') {
        return null;
    }
    // Return a string by default
    return value === undefined || value === null ? value : String(value);
};
/**
 * Convert a value to a specified data type
 *
 * TODO Try to force type return value
 *
 * TODO2 In float and integer, is the undefined returned value ok?
 *
 * TODO3 What about other types, if datatype is string and we get an array, it
 * returns an array... not as humanly expected. But this is not documented and
 * it is used in the wild in many survey. Let's revisit when old usages can
 * version evolution to its current state and we can evolve the API
 *
 * @param value The value to parse
 * @param datatype The type of data
 * @param asArray whether this datatype is expected to be an array (for example,
 * it would be true for checkboxes or multiselect)
 * @returns The parsed value converted to the specified data type, or the original value if no conversion is applied.
 */
const parseValue = function (value, datatype, asArray = false) {
    if (!asArray && !Array.isArray(value)) {
        // If the value is not an array, and the value is not expected as array, return the parsed value
        return _parseSingleValue(value, datatype);
    }
    else if (!asArray && Array.isArray(value)) {
        // If the value is an array, but not expected as array, return the first value parsed
        if (value.length > 0) {
            return _parseSingleValue(value[0], datatype);
        }
        else {
            return null;
        }
    }
    else if (asArray && Array.isArray(value)) {
        // If the value is an array, and expected as array, we will parse each value in the array
        const parsedValues = value
            .map((v) => _parseSingleValue(v, datatype))
            .filter((v) => v !== undefined && v !== null);
        // If the parsed values are empty, return null
        return parsedValues.length === 0 ? null : parsedValues;
    }
    else {
        // If the value is not an array, but expected as array, we will return an array with the parsed value
        const parsedValue = _parseSingleValue(value, datatype);
        return parsedValue === undefined || parsedValue === null ? parsedValue : [parsedValue];
    }
};
exports.parseValue = parseValue;
/**
 * Get a response object or value for a specific path in the interview
 *
 * @param interview The interview object
 * @param path The path for which to get the value (dot-separated fields)
 * @param defaultValue The default value to return if the value is null or
 * undefined
 * @param relativePath The relative path from the given path (with prefixed ../
 * to go back in the path)
 * @returns The value of this path
 */
const getResponse = (
// TODO Can this really be undefined? it was previously in the if clause, but try to make it not be undefined
interview, path, defaultValue = undefined, relativePath) => {
    const newPath = (0, exports.getPath)(path, relativePath);
    if (newPath && interview) {
        const value = (0, get_1.default)(interview.response, newPath, defaultValue);
        return value === null || value === undefined ? defaultValue : value;
    }
    else {
        return null;
    }
};
exports.getResponse = getResponse;
/**
 * Sets the value for a response at a given path
 *
 * TODO Validate the return type: we receive an interview, we return a response!
 * That was in the legacy code
 *
 * @param interview The interview object
 * @param path The path for which to set the value (dot-separated fields)
 * @param value value to set
 * @param relativePath The relative path from the given path (with prefixed ../
 * to go back in the path)
 * @returns The interview response with the field set
 */
const setResponse = (
// TODO Can this really be undefined? it was previously in the if clause, but try to make it not be undefined
interview, path, value = undefined, relativePath) => {
    const newPath = (0, exports.getPath)(path, relativePath);
    if (newPath && interview) {
        return (0, set_1.default)(interview.response, newPath, value);
    }
    else {
        // TODO Keep the null value for return for legacy purposes, but it should return the object
        return null;
    }
};
exports.setResponse = setResponse;
/**
 * Get the household object in the interview response, or an empty object if
 * the household has not been initialized
 *
 * @param interview The interview object
 * @returns The household object
 * @deprecated use {@link odSurveyHelpers.getHousehold} instead
 */
const getHousehold = (interview) => odSurveyHelpers.getHousehold({ interview });
exports.getHousehold = getHousehold;
/**
 * Get the currently active person, as defined in the interview response. If
 * the active person is not set but there are persons defined, the first one
 * will be returned. If the person is not found, an empty object will be
 * returned.
 *
 * @param interview The interview object
 * @returns The current person object
 * @deprecated use {@link odSurveyHelpers.getActivePerson} instead
 */
const getCurrentPerson = (interview) => odSurveyHelpers.getActivePerson({ interview });
exports.getCurrentPerson = getCurrentPerson;
/**
 * Get a validation value value for a specific path in the interview
 *
 * TODO: Type the validations properly
 *
 * @param interview The interview object
 * @param path The path for which to get the value (dot-separated fields)
 * @param defaultValue The default value to return if the value is null or
 * undefined
 * @returns The validation value of this path, or `null` if the path does not have a validation value
 */
const getValidation = (interview, path, defaultValue) => {
    const validation = (0, get_1.default)(interview.validations, path, defaultValue);
    return LE._booleish(validation);
};
exports.getValidation = getValidation;
/**
 * Sets the value for a validation at a given path
 *
 * @param interview The interview object
 * @param path The path for which to set the value (dot-separated fields)
 * @param value value to set
 * @param relativePath The relative path from the given path (with prefixed ../
 * to go back in the path)
 * @returns The interview response with the field set
 */
const setValidation = (interview, path, value, relativePath) => {
    const newPath = (0, exports.getPath)(path, relativePath);
    if (newPath) {
        (0, set_1.default)(interview.validations, newPath, value);
    }
    return interview;
};
exports.setValidation = setValidation;
/**
 * Create a single comma-separated string with the fields received in parameter,
 * to send as geocoding query string
 *
 * TODO Is this really for geocoding, do all geocoders require the same kind of
 * string? Or is it specific for something particular? Once the geocoding
 * widgets are migrated to typescript and properly typed, revisit this
 * function's pertinence.
 *
 * @param fields An array of values to encode in a comma-separated query
 * @returns A single comma-separated string, or undefined if there is no valid
 * field to encode
 */
const formatGeocodingQueryStringFromMultipleFields = (fields) => {
    const queryArray = [];
    for (let i = 0, count = fields.length; i < count; i++) {
        const value = fields[i];
        if (typeof value === 'string') {
            queryArray.push(value);
        }
        else if (typeof value === 'number') {
            queryArray.push(String(value));
        }
    }
    return queryArray.length === 0 ? undefined : queryArray.join(', ');
};
exports.formatGeocodingQueryStringFromMultipleFields = formatGeocodingQueryStringFromMultipleFields;
/**
 * Test a string against a regex to see if it is a phone number
 * @param maybeNumber - String to test.
 * @returns True if string is a phone number.
 */
const isPhoneNumber = (maybeNumber) => {
    return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(maybeNumber);
    // Thanks to https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
};
exports.isPhoneNumber = isPhoneNumber;
/**
 * @deprecated Use {@link odSurveyHelpers.getPersons} instead
 * */
const getPersons = (interview) => odSurveyHelpers.getPersons({ interview });
exports.getPersons = getPersons;
/**
 * @deprecated Use {@link odSurveyHelpers.getPersonsArray} instead
 */
const getPersonsArray = (interview) => odSurveyHelpers.getPersonsArray({ interview });
exports.getPersonsArray = getPersonsArray;
/**
 * @deprecated Use {@link odSurveyHelpers.getVisitedPlaces} instead
 */
const getVisitedPlaces = (journey) => odSurveyHelpers.getVisitedPlaces({ journey });
exports.getVisitedPlaces = getVisitedPlaces;
/**
 * @deprecated Use {@link odSurveyHelpers.getVisitedPlacesArray} instead
 */
const getVisitedPlacesArray = (journey) => odSurveyHelpers.getVisitedPlacesArray({ journey });
exports.getVisitedPlacesArray = getVisitedPlacesArray;
/**
 * Replace visited places that are shortcuts to the given location by the data
 * of this location. Only the first shortcut will be replaced, the others will
 * use the first place as new shortcut
 * @param interview The interview
 * @param visitedPlacesPath The path of the visited place to replace
 * @deprecated Use {@link odSurveyHelpers.replaceVisitedPlaceShortcuts} instead
 */
const replaceVisitedPlaceShortcuts = (interview, visitedPlacesPath) => odSurveyHelpers.replaceVisitedPlaceShortcuts({ interview, shortcutTo: visitedPlacesPath });
exports.replaceVisitedPlaceShortcuts = replaceVisitedPlaceShortcuts;
const startDateGreaterEqual = (startDate, compare) => {
    const interviewStart = startDate ? moment_1.default.unix(startDate) : undefined;
    const dateCompare = compare ? (0, moment_1.default)(compare) : undefined;
    const surveyStartDate = dateCompare && dateCompare.isValid() ? dateCompare : undefined;
    if (interviewStart !== undefined && surveyStartDate !== undefined) {
        return interviewStart >= surveyStartDate;
    }
    return null;
};
/**
 * Check if the survey has started based on the interview start date and the configured survey start date.
 *
 * @param {UserInterviewAttributes} interview The interview object.
 * @returns {boolean} `true` if the survey has started, `false` otherwise.
 */
const surveyStarted = (interview) => {
    const isSurveyStarted = startDateGreaterEqual(interview.response._startedAt, project_config_1.default.surveyStart);
    return isSurveyStarted === null ? true : isSurveyStarted;
};
exports.surveyStarted = surveyStarted;
/**
 * Check if the survey has ended based on the interview start date and the configured survey end date.
 *
 * @param {UserInterviewAttributes} interview The interview object.
 * @returns {boolean} `true` if the survey has ended, `false` otherwise.
 */
const surveyEnded = (interview) => {
    const isSurveyEnded = startDateGreaterEqual(interview.response._startedAt, project_config_1.default.surveyEnd);
    return isSurveyEnded === null ? true : isSurveyEnded;
};
exports.surveyEnded = surveyEnded;
const interviewOnOrAfter = (date, interview) => {
    return startDateGreaterEqual(interview.response._startedAt, date);
};
exports.interviewOnOrAfter = interviewOnOrAfter;
/**
 * @typedef {Object} GroupedObjectsResult
 * @property {Object} changedValuesByPath The changed values by path.
 * @property {string[]} unsetPaths The unset paths.
 */
/**
 * Add new grouped objects to the interview at path with the given attributes,
 * at the given sequence. Note that object sequences are 1-based. So the first
 * object is at sequence 1.
 * @param {UserInterviewAttributes} interview The interview object
 * @param {number} newObjectsCount The number of new objects to add
 * @param {(number|undefined)} insertSequence The sequence at which to insert
 * the new objects. Any negative value will add at the end of the array. The
 * first object is at sequence 1.
 * @param {string} path Path at which to add the grouped objects. New objects
 * will be added at the insertSequence position of the existing objects.
 * @param {Object[]} [attributes=[]] An array of attributes with which to
 * initialize the objects. Each attributes object in the array will be used to
 * initialize the new objects at the same position.
 * @returns {Object} The changed values by path
 */
const addGroupedObjects = (interview, newObjectsCount, insertSequence, path, attributes = []) => {
    const changedValuesByPath = {};
    const groupedObjects = (0, get_1.default)(interview.response, path, {});
    const groupedObjectsArray = (0, sortBy_1.default)(Object.values(groupedObjects), ['_sequence']);
    // Make sure sequence is within bounds:
    const objStartSequence = typeof insertSequence !== 'number' || insertSequence <= -1
        ? groupedObjectsArray.length + 1
        : Math.min(groupedObjectsArray.length + 1, Math.max(1, insertSequence));
    // increment sequences of groupedObjects after the insertSequence:
    for (let seq = objStartSequence, count = groupedObjectsArray.length; seq <= count; seq++) {
        const groupedObject = groupedObjectsArray[seq - 1];
        changedValuesByPath[`response.${path}.${groupedObject._uuid}._sequence`] = seq + newObjectsCount;
    }
    for (let i = 0; i < newObjectsCount; i++) {
        const uniqueId = (0, uuid_1.v4)();
        const newSequence = objStartSequence + i;
        const newObjectAttributes = attributes[i] ? attributes[i] : {};
        changedValuesByPath[`response.${path}.${uniqueId}`] = Object.assign({ _sequence: newSequence, _uuid: uniqueId }, newObjectAttributes);
        changedValuesByPath[`validations.${path}.${uniqueId}`] = {};
    }
    return changedValuesByPath;
};
exports.addGroupedObjects = addGroupedObjects;
/**
 * Remove grouped objects from the interview at the given path. The sequences of
 * the remaining objects will be modified to be continuous.
 * @param {UserInterviewAttributes} interview The interview object
 * @param {(string|string[])} paths The paths of the objects to remove
 * @returns {GroupedObjectsResult} An object containing the changed values by path and the unset paths.
 */
const removeGroupedObjects = (interview, paths) => {
    // allow single path:
    const removePaths = Array.isArray(paths) ? paths : [paths];
    if (removePaths.length === 0) {
        return [{}, []];
    }
    const unsetPaths = [];
    const valuesByPath = {};
    let pathRemovedCount = 0;
    const groupedObjects = (0, exports.getResponse)(interview, removePaths[0], {}, '../');
    const groupedObjectsArray = (0, sortBy_1.default)(Object.values(groupedObjects), ['_sequence']);
    for (let i = 0, count = groupedObjectsArray.length; i < count; i++) {
        const groupedObject = groupedObjectsArray[i];
        const groupedObjectPath = (0, exports.getPath)(removePaths[0], `../${groupedObject._uuid}`);
        if (groupedObjectPath !== null && removePaths.includes(groupedObjectPath)) {
            unsetPaths.push(`response.${groupedObjectPath}`);
            unsetPaths.push(`validations.${groupedObjectPath}`);
            pathRemovedCount++;
        }
        else {
            if (pathRemovedCount > 0) {
                valuesByPath['response.' + groupedObjectPath + '._sequence'] =
                    (groupedObject._sequence || i + 1) - pathRemovedCount;
            }
        }
    }
    return [valuesByPath, unsetPaths];
};
exports.removeGroupedObjects = removeGroupedObjects;
/**
 * Get the widget choice corresponding to the value for a radio, checkbox or
 * select widget
 *
 * @param {Object} options - The options object.
 * @param {WidgetConfig} options.widget The widget for which to get the choice
 * @param {string|boolean} options.value The value to find
 * @param {UserInterviewAttributes} options.interview The interview object
 * @param {string} options.path The path of the field being parsed, in the
 * interview response
 * @returns The choice corresponding to the value, or `undefined` if the widget
 * does not have choices or if the choice is not found
 */
const getWidgetChoiceFromValue = ({ widget, value, interview, path }) => {
    if (widget.type !== 'question' ||
        (widget.inputType !== 'radio' && widget.inputType !== 'checkbox' && widget.inputType !== 'select')) {
        return undefined;
    }
    const choices = typeof widget.choices === 'function' ? widget.choices(interview, path) : widget.choices;
    const baseChoices = choices.flatMap((choice) => choice.choices || [choice]);
    return baseChoices.find((choice) => choice.value === value);
};
exports.getWidgetChoiceFromValue = getWidgetChoiceFromValue;
/**
 * Check if the section is complete
 *
 * @param {Object} options - The options object.
 * @param {UserInterviewAttributes} options.interview - The interview object.
 * @param {string} options.sectionName - The name of the section to check.
 * @returns {boolean | null} - Returns true if the section is complete, false if
 * not, or null if the section is not found.
 *
 * @description This function checks if the section is complete by looking at
 * the `interview.response._sections.${sectionName}._isCompleted` field.
 * @deprecated Use the `isSectionCompleted` function in the `navigationHelpers`
 * module instead, which accounts for the iteration context as well.
 */
const isSectionComplete = ({ interview, sectionName }) => {
    const isSectionComplete = (0, exports.getResponse)(interview, `_sections.${sectionName}._isCompleted`, null);
    return isSectionComplete;
};
exports.isSectionComplete = isSectionComplete;
/**
 * Calculate the survey completion percentage based on the number of completed sections.
 * The percentage begins at 0% when starting the first section and reaches 100% when the last section is initiated.
 *
 * @param {Object} options - The options object.
 * @param {UserInterviewAttributes} options.interview - The interview object.
 * @param {Object} options.sections - The sections object.
 * @param {string} options.sectionName - The shortname of the current section.
 * @param {string} options.sectionTarget - The target section for the completion rate ('currentSection' or 'nextSection').
 * @returns {number} - The calculated completion percentage.
 */
const calculateSurveyCompletionPercentage = ({ interview, sections, sectionName, sectionTarget }) => {
    var _a;
    const LAST_SECTION_NAME = 'completed'; // NOTE: Only survey with the last section named 'completed' are supported for this function.
    const MINIMUM_COMPLETION_PERCENTAGE = 0;
    const MAXIMUM_COMPLETION_PERCENTAGE = 100;
    // Get the stored completion percentage from the interview response
    const storedCompletionPercentage = ((_a = interview === null || interview === void 0 ? void 0 : interview.response) === null || _a === void 0 ? void 0 : _a._completionPercentage) || MINIMUM_COMPLETION_PERCENTAGE;
    // Count the number of sections without the last one
    const sectionsWithoutCompleted = Object.keys(sections).filter((sectionName) => sectionName !== LAST_SECTION_NAME);
    const totalSectionsWithoutCompleted = sectionsWithoutCompleted.length;
    // Increment the index if the section target is 'nextSection'
    let sectionTargetIndex = Object.keys(sections).findIndex((key) => key === sectionName);
    if (sectionTarget === 'nextSection') {
        sectionTargetIndex = Math.min(sectionTargetIndex + 1, totalSectionsWithoutCompleted);
    }
    // Return the maximum survey completion percentage
    const targetCompletionPercentage = Number(((sectionTargetIndex / totalSectionsWithoutCompleted) * 100).toFixed(0));
    const completionPercentage = Math.min(MAXIMUM_COMPLETION_PERCENTAGE, Math.max(storedCompletionPercentage, targetCompletionPercentage));
    return completionPercentage;
};
exports.calculateSurveyCompletionPercentage = calculateSurveyCompletionPercentage;
//# sourceMappingURL=helpers.js.map